import api from '../configs/api.config';
import { TicketLifecycleData } from '../types/ticketLifecycle.types';
import { WEFResponse } from '../Types';

export async function getTicketLifecycle(ticketId: string): Promise<TicketLifecycleData> {
  const response = await api.get<WEFResponse<TicketLifecycleData>>(`/Ticket/Lifecycle/${ticketId}`);
  return response.data.data;
}
